import { VxeRadio } from 'vxe-pc-ui';
import defPropMixin from './defPropMixin';
export default {
  name: 'XRadio',
  components: {
    VxeRadio
  },
  mixins: [defPropMixin],
  props: {
    title: {
      type: String,
      default: ''
    },
    strict: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Boolean]
    },
    label: {
      type: [String, Number, Boolean]
    },
    name: {
      type: String
    }
  },
  emits: ['change', 'update:value'],
  setup(props, {
    emit
  }) {
    const handleChanged = ({
      label,
      value,
      $event
    }) => {
      emit('change', {
        label,
        value,
        $event
      });
      emit('update:value', value, $event);
    };
    return {
      handleChanged
    };
  }
};